export const arrayPartition = (arr, predicateFn) => {
  const result = { true: [], false: [] };
  for (var idx = 0; idx < arr.length; idx++) {
    const element = arr[idx];
    result[!!predicateFn(element) ? 'true' : 'false'].push(element);
  }
  return [result.true, result.false];
};

export const arrayGroupBy = (arr, predicateFn) => {
  const result = new Map();
  const memo = {};

  for (var idx = 0; idx < arr.length; idx++) {
    const element = arr[idx];
    const rawKey = predicateFn(element);
    const memoKey = JSON.stringify(rawKey);
    const key = memo[memoKey] ?? ((memo[memoKey] = rawKey) && rawKey);

    if (!result.get(key)) {
      result.set(key, [element]);
    } else {
      result.get(key).push(element);
    }
  }

  return result;
};

export const generateCompare =
  (...parts) =>
  (a, b) => {
    const result = parts
      .map((p) => (typeof p === 'function' ? p : (x) => x?.[p]))
      .reduce((result, getPart) => {
        if (result) return result;

        const valueA = getPart(a);
        const valueB = getPart(b);

        if (valueA < valueB) return -1;
        if (valueA > valueB) return 1;
        return 0;
      }, 0);

    return result;
  };

export const arrayDedupe = (array) => array.filter((item, index) => array.indexOf(item) === index);

export const filterUniquesBy = <T>(uniqueKey: keyof T, objects: T[]): T[] => {
  const ids = objects.map((object) => object[uniqueKey]);
  return objects.filter((object, index) => !ids.includes(object[uniqueKey], index + 1));
};
